export const FETCH_DELETE_OWNER_REQUEST = 'FETCH_DELETE_OWNER_REQUEST'
export const FETCH_DELETE_OWNER_SUCCESS = 'FETCH_DELETE_OWNER_SUCCESS'
export const FETCH_DELETE_OWNER_FALUIRE = 'FETCH_DELETE_OWNER_FALUIRE'
